<div class="auth-without-login-verify-otp">
  <div class="verification-notify-step" *ngIf="verifyNowStep1">
    <div class="verify-mobile-number">
      <img src="/assets/images/verify-mobile.svg" alt="verify-mobile">
      <h3>Verify your mobile number</h3>
      <p>
        To prevent misuse of your account, we have implemented a two-factor authentication system.
        Kindly verify your mobile number to continue.
      </p>
      <button mat-flat-button color="primary" (click)="verifyNow()"> Verify Now</button>
      <div class="proceed-link">
        <a *ngIf="loadingFrom === 'dashboard'" class="anchor-link" (click)="closeModel()">Proceed without
          verification</a>
      </div>
    </div>
  </div>
  <div class="verification-notify-step" *ngIf="sendOtpStep2">
    <div class="verify-mobile-number">

      <img src="/assets/images/verify-mobile.svg" alt="verify-mobile">
      <h3>Verify your mobile number</h3>

      <form [formGroup]="phoneNumberForm" autocomplete="off" novalidate>
        <mat-form-field [floatLabel]="'never'" class="button_type shadow-input country-code">
          <label class="mb-2">Mobile Number</label>
          <span matPrefix>{{userDetails.countryCode}}</span>
          <input matInput type="tel" inputmode="numeric" pattern="[0-9]*"
            autocomplete="tel-national" maxlength="9" placeholder="412345678"
            formControlName="phone" (input)="sanitizePhoneNumber($event)">
          <span class="wpt-tag error" matSuffix>Not Verified</span>
          <!-- <span class="wpt-tag success" matSuffix>Verified</span> -->
          <mat-error
            *ngIf="phoneNumberForm.controls.phone.invalid && (phoneNumberForm.controls.phone.dirty || phoneNumberForm.controls.phone.touched)">
            <span *ngIf="phoneNumberForm.controls.phone.errors.required">
              Phone field should not be empty.
            </span>
            <span *ngIf="phoneNumberForm.controls.phone.errors.minlength">
              Phone number should not be less than 9 digits.
            </span>
            <span *ngIf="phoneNumberForm.controls.phone.errors.maxlength">
              Phone number should not be greater than 9 digits.
            </span>
            <span
              *ngIf="!phoneNumberForm.controls.phone.errors.required && phoneNumberForm.controls.phone.errors.pattern">
              Phone number should only contain digits.
            </span>
            <span *ngIf="formError?.phone">{{formError.phone}}</span>
          </mat-error>
        </mat-form-field>
        <div class="text-center">
          <button class="btn btn-blue btn-md btn-radius mt-4" mat-button type="submit"
            (click)="sendOtp(phoneNumberForm)" [disabled]="verificationLoader">
            {{verificationLoader ? 'Please Wait...' : 'Send OTP'}}
          </button>
          <div class="proceed-link">
            <a class="anchor-link" *ngIf="loadingFrom === 'dashboard'" (click)="closeModel()">Proceed without
              verification</a>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="verification-notify-step" *ngIf="verifyOtpStep3">
    <div class="verify-mobile-number">
      <app-otp-verification *ngIf="showOtpComponent" #otpComponent [data]="phoneVerificationData"
        [verificationFrom]="userDetails.verificationFrom" (signupOtpVerifyResponse)="otpResponse($event)"
        (changePhone)="changePhoneNumber($event)">
      </app-otp-verification>
      <div class="proceed-link">
        <a class="anchor-link" *ngIf="loadingFrom === 'dashboard'" (click)="closeModel()">Proceed without
          verification</a>
      </div>
    </div>
  </div>
</div>